import { useQuery } from '@tanstack/react-query';
import { useApiClient } from './useApiClient';

export interface AlertEvent {
  alertTypeId: number;
  customerName: string;
  category: string;
  subtype: string;
  categoryDisplayName: string;
  subtypeDisplayName: string;
  eventType: string;
  startTime: string | null;
  endTime: string | null;
  createdAt: string;
  metrics: Record<string, unknown>;
  description: string;
}

interface MeterAlertsResponse {
  activeAlerts: AlertEvent[];
  endedAlerts: AlertEvent[];
}

export function useMeterAlerts(sensorId: string | undefined) {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ['meter-alerts', sensorId],
    queryFn: () => apiClient.get<MeterAlertsResponse>(`meters/${sensorId}/alerts`),
    enabled: !!sensorId,
  });
}

export interface AlertHistoryEvent {
  eventType: string;
  startTime: string | null;
  endTime: string | null;
  createdAt: string;
  metrics: Record<string, unknown>;
  description: string;
}

interface AlertHistoryResponse {
  events: AlertHistoryEvent[];
}

export function useMeterAlertHistory(
  sensorId: string | undefined,
  alertTypeId: number | null,
  startTime: string | null,
  createdAt: string | null,
) {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ['meter-alert-history', sensorId, alertTypeId, startTime, createdAt],
    queryFn: () =>
      apiClient.get<AlertHistoryResponse>(
        `meters/${sensorId}/alert-history?alertTypeId=${alertTypeId}&startTime=${
          encodeURIComponent(startTime!)
        }&createdAt=${encodeURIComponent(createdAt!)}`,
      ),
    enabled: !!sensorId && alertTypeId !== null && startTime !== null && createdAt !== null,
  });
}
